import(/* webpackMode: "eager" */ "/home/runner/work/payments-checkout/payments-checkout/src/app/[locale]/error.tsx");
